import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './context/UserContext';
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';
import { MenuProvider } from './context/MenuContext';
import { TostMessageProvider } from './context/TostMessage';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TostMessageProvider>
          <CookiesProvider defaultSetOptions={{ path: '/' }}>
            <UserProvider>
              <MenuProvider>
                  <PayPalScriptProvider options={{ "client-id": "Ab19q1-JfQlalR3hpGrCjB_ZYW_fhiSESMf2hlwONmD01esqu7ykcsClh83DMwuGFRElJeFwPPLDKqQr" }}>
                    <App />
                  </PayPalScriptProvider>
              </MenuProvider>
            </UserProvider>
          </CookiesProvider>
      </TostMessageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
